import { ValidationProps } from 'ui';
import { ScreenField, ScreenPicker } from 'app/area/codetable/item/screen-renderer/types';
import { SafetyLimit } from 'app/area/codetable/item/types-store';
import { createSafetyLimitId } from 'app/area/codetable/item/codetable-item-helpers';

const getServerValidation = (safetyLimitValidation: ValidationProps | undefined, appId: number): ValidationProps | undefined => {
  if (!safetyLimitValidation) {
    return undefined;
  }
  const matchingMessages = safetyLimitValidation.messages?.filter(m => m.parameters?.application === appId);
  return matchingMessages?.length ? { ...safetyLimitValidation, messages: matchingMessages } : undefined;
};

export const getSafetyLimitValidation = (
  fieldKey: ScreenPicker | ScreenField,
  safetyLimit: SafetyLimit,
  validation: { [key: string]: ValidationProps }
): { fieldValidation: ValidationProps | undefined; serverValidation: ValidationProps | undefined } => {
  const appId = safetyLimit?.application?.value;
  const fieldValidation = validation?.[createSafetyLimitId(fieldKey, appId)];
  const serverValidation = getServerValidation(validation?.safetyLimit, appId);
  return { fieldValidation, serverValidation };
};
